import { createValidator, ErrorObject, range, required } from 'util/validation'

import AtestadoModel from '../components/model-atestado'
import { validateCpfCnsAtestado } from '../validator-utils-atestado'

export const solicitacaoFraldasGeriatricasFormValidator = (possuiCpfCns: boolean) =>
  createValidator<AtestadoModel>(
    {
      tamanhoFralda: required,
      unidadesPorDia: [required, range(1, 100)],
    },
    (values: AtestadoModel, errors: ErrorObject<AtestadoModel>) => {
      validateCpfCnsAtestado(values, errors, possuiCpfCns)

      return errors
    }
  )
